import axios from "axios";
import { HOST_URL } from "../constants/Constants";

export const getAllFluids = async () => {
  const data = await axios
    .get(HOST_URL + "/fluids/getAll", {
      withCredentials: true,
    })
    .catch((error) => {
      console.log("error = ", error);
    });
  return data.data;
};